export default "__VITE_ASSET__DmQ31jI3__"